import React, { useEffect, useState } from 'react';
import { api } from '../../api';
import { colors, fontFamily } from '../../theme';

export default function CasinoTab({ showToast, onGameClose }) {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(true);
  const [launchUrl, setLaunchUrl] = useState(null);
  const [launchingSlug, setLaunchingSlug] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api.getCasinoGames()
      .then(data => { if (!cancelled) setGames(data.games || []); })
      .catch(() => { if (!cancelled) showToast?.('Failed to load casino games', 'error'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [showToast]);

  const handleClose = () => {
    setLaunchUrl(null);
    // Wallet debits/credits during play only land in our DB via the
    // provider's callbacks — refresh account balance now that the player
    // is back out of the game, same as the refresh a re-login triggers.
    onGameClose?.();
  };

  const handlePlay = async (slug) => {
    setLaunchingSlug(slug);
    try {
      const data = await api.launchCasinoGame(slug);
      setLaunchUrl(data.launchUrl);
    } catch (err) {
      showToast?.(err.response?.data?.error || 'Failed to launch game', 'error');
    } finally {
      setLaunchingSlug(null);
    }
  };

  if (launchUrl) {
    return (
      <div className="fixed inset-0 z-50" style={{ background: '#000' }}>
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 z-10 px-3 py-1.5 rounded-lg text-sm font-medium"
          style={{ background: colors.surfaceBg, color: colors.textPrimary, fontFamily }}
        >
          Close
        </button>
        <iframe
          src={launchUrl}
          title="Casino game"
          width="100%"
          height="100%"
          frameBorder="0"
          allowFullScreen
          style={{ border: 'none' }}
        />
      </div>
    );
  }

  if (loading) {
    return (
      <div className="p-6 text-center" style={{ color: colors.textMuted, fontFamily }}>
        Loading games…
      </div>
    );
  }

  if (games.length === 0) {
    return (
      <div className="p-6 text-center" style={{ color: colors.textMuted, fontFamily }}>
        No casino games available right now.
      </div>
    );
  }

  return (
    <div
      className="grid gap-3 p-4"
      style={{ fontFamily, gridTemplateColumns: 'repeat(auto-fill, minmax(110px, 1fr))' }}
    >
      {games.map(game => (
        <button
          key={game.slug}
          onClick={() => handlePlay(game.slug)}
          disabled={launchingSlug === game.slug}
          className="rounded-xl overflow-hidden text-left"
          style={{ background: colors.cardBg, boxShadow: colors.shadowCard }}
        >
          {game.thumbnail && (
            <img src={game.thumbnail} alt={game.name} className="w-full aspect-square object-cover" />
          )}
          <div className="p-2">
            <div style={{ color: colors.textPrimary, fontWeight: 600, fontSize: 12 }}>
              {launchingSlug === game.slug ? 'Loading…' : game.name}
            </div>
          </div>
        </button>
      ))}
    </div>
  );
}
